import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

// export const columns: GridColumnConfig[] = [
//   {
//     title: 'Service Name',
//     field: 'serviceName',
//     filter: 'text',
//     searchable: true,
//   },
//   {
//     title: 'Predecessor',
//     field: 'predecessor',
//     filter: 'text',
//   },
//   {
//     title: 'Billing Type',
//     field: 'billingType',
//     filter: 'text',
//   },
//   {
//     title: 'Forecast Days',
//     field: 'forecastDays',
//     filter: 'text',
//   },
//   {
//     title: 'Invoice Amount ($)',
//     field: 'price',
//     filter: 'text',
//     fieldType: 'currency',
//   },
// ];

export const columns: GridColumnConfig[] = [
  {
    title: 'Name',
    field: 'typeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Type',
    field: 'itemType',
    filter: 'text',
  },
  {
    title: 'Bundle Name',
    field: 'bundleName',
    filter: 'text',
  },

  {
    title: 'Services Count',
    field: 'servicesCount',
    filter: 'text',
  },
  {
    title: 'Split Amount',
    field: 'splitAmount',
    filter: 'text',
  },
  {
    title: 'Bundle Price',
    field: 'bundlePrice',
    filter: 'text',
  },
  {
    title: 'Invoice Amount',
    field: 'invoiceAmount',
    filter: 'text',
    isFooterCell: true,
  },
  {
    title: 'Accrual Amount',
    field: 'accrualAmount',
    filter: 'text',
  },

  {
    title: 'Option',
    field: 'option',
    filter: 'text',
  },
];
